import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await api.post("/auth/login", form);
      setUser(res.data);
      navigate(res.data.role === "admin" ? "/admin" : "/area-personale");
    } catch (err) {
      setError(formatApiError(err, "Email o password non corretti"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16 sm:px-6 animate-fade-up" data-testid="login-page">
      <div className="card-elegant">
        <h1 className="font-heading text-2xl font-bold text-bordeaux-dark sm:text-3xl">Accedi</h1>
        <p className="mt-2 text-sm text-muted-foreground">Entra nella tua Area Personale ENPALSBOX.</p>

        {error && (
          <div data-testid="login-error" className="mt-4 rounded-lg border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-800">
            {error}
          </div>
        )}

        <form onSubmit={submit} noValidate className="mt-6 space-y-5" data-testid="login-form">
          <div>
            <label className="label-elegant" htmlFor="login-email">Email</label>
            <input id="login-email" type="email" data-testid="login-email-input" className="input-elegant" required
              value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div>
            <label className="label-elegant" htmlFor="login-password">Password</label>
            <input id="login-password" type="password" data-testid="login-password-input" className="input-elegant" required
              value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          </div>
          <div className="-mt-2 text-right">
            <Link to="/recupera-password" data-testid="login-forgot-password-link" className="text-sm font-medium text-bordeaux hover:underline">
              Password dimenticata?
            </Link>
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit-button" className="btn-bordeaux w-full">
            {loading ? "ACCESSO IN CORSO..." : "ACCEDI"}
          </button>
        </form>

        <p className="mt-5 text-center text-sm text-muted-foreground">
          Non hai un account?{" "}
          <Link to="/iscriviti" data-testid="login-register-link" className="font-semibold text-bordeaux hover:underline">
            Iscriviti
          </Link>
        </p>
      </div>
    </div>
  );
}
